import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas
} from "../ZeusAPIClient.js";

//获取考勤汇总信息
async function GeteAttendanceSummary(data) {
  return await GetByParas("fb9948c6-3eff-4137-a23e-8f461d38cea0", data);
}

//获取考勤查询信息
async function GeteAttendanceSearch(
  pageIndex,
  pageSize,
  roleKey,
  userId,
  startTime,
  endTime,
  mainDeptsName,
  name,
  userCode
) {
  var para = {
    p: pageIndex, //页码
    size: pageSize, //页大小
    roleKey: roleKey, //当前登录角色
    userId: userId //当前登录人
  };
  var data = {
    startTime: startTime, //开始时间
    endTime: endTime, //结束时间
    mainDeptsName: mainDeptsName, //部门
    name: name, //姓名
    userCode: userCode //工号
  };
  return await PostWithParas(
    "48ff0de6-9469-43bd-8c36-40ed59ed8b0e",
    para,
    data
  );
}

//获取考勤日历
async function GetAttendanceDay(data) {
  //console.log(JSON.stringify(data));
  return await GetByParas("c6695d3a-76fa-4547-ba42-adce8a4a37af", data);
}

async function GetHomeAttendanceDay(data) {
  return await GetByParas("eb86f05c-37fc-4998-8755-bec9fcdaf791", data);
}

//获取某一天的打卡详情
async function GetAttendanceDayOnePc(data) {
  //console.log(JSON.stringify(data));
  return await GetByParas("70a40b50-980d-4f0e-941e-dae4d9dc2628", data);
}

export {
  GeteAttendanceSearch,
  GeteAttendanceSummary,
  GetAttendanceDay,
  GetAttendanceDayOnePc,
  GetHomeAttendanceDay
};
